<template>
  <div class="list-meta__item">
    <i v-if="icon" :class="`fa fa-${icon} fa-fw`"></i>
    <span class="list-meta__label">
      <template v-if="booking.date_options">Date Options:</template>
      <template v-else>Event Date:</template>
    </span>
    <span class="list-meta__text">
      <template v-if="booking.date_options">{{ booking.date_options | implodeDates($user.date_format_preference) | nullable }}</template>
      <template v-else-if="booking.date">{{ dateUserTz | date($user.date_format_preference) | nullable }}</template>
      <template v-else>Date is unconfirmed</template>
    </span>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    icon: {
      type: String,
      default: null
    },
    booking: {
      type: Object,
      required: true
    }
  },

  computed: {
    dateUserTz () {
      return moment.utc(this.booking.utc_date).tz(this.$user.timezone)
    }
  }
}
</script>
